<mat-card class="card-hospital-mobile">
    <div class="hospital-image-container-mobile">
        <img class="hospital-image-mobile" 
        [style.transform]="name.includes('Long Beach Medical Center') ? 'scale(1.52)' : ''"
        src="{{photo}}">
    </div>
    <div class="hospital-container"> 
        <mat-card-content>
            <div *ngIf="name.includes('Medical Center')" class="hospital-title-mobile">
                <div>{{name.split('Medical Center')[0]}}</div>
                <div>Medical Center</div>
            </div>
            <div *ngIf="name.includes('Miller')" class="hospital-title-mobile">
                <div style="width: 182px;">Miller Children's & Women's</div>
                <div style="width: 182px;">Hospital</div>
            </div>
        </mat-card-content>
        <mat-card-actions>
            <div class="hospital-action-container-mobile">
                <div class="hospital-address-mobile">
                    <img src="assets/images/address-icon.svg" class="address-icon-mobile">
                    <div style="display: flex; flex-direction: column;">
                        <div>{{address}}</div>
                        <div>{{city}}, {{state}} {{zip}}</div>
                    </div>
                </div>
                <div *ngIf="phone != null" class="hospital-phone-mobile link" (click)="callNow()">
                    <img src="assets/images/phone-icon.svg"  class="phone-icon-mobile">
                    {{phone}}
                </div>
                <div class="hospital-direction-mobile link" (click)="getDirection()">
                    <img src="assets/images/map-icon.svg"  class="map-icon-mobile">
                    {{getDirectionsText}}
                </div>
            </div>
        </mat-card-actions>
    </div>
</mat-card>